/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Adv_TitleInputs */

const en_pc_cmp_adv_title = /** @type {(inputs: Pc_Cmp_Adv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where PdfCraft wins`)
};

const zh_pc_cmp_adv_title = /** @type {(inputs: Pc_Cmp_Adv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 的优势`)
};

/**
* | output |
* | --- |
* | "Where PdfCraft wins" |
*
* @param {Pc_Cmp_Adv_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_adv_title = /** @type {((inputs?: Pc_Cmp_Adv_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Adv_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_adv_title(inputs)
	return zh_pc_cmp_adv_title(inputs)
});
export { pc_cmp_adv_title as "pc.cmp.adv_title" }